import { useFilteredHabits as _useFilteredHabits } from '@griply/hooks';
import { Habit, TaskFilterOptions } from '@griply/types';
import { DeletedFilter } from '@griply/utils';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';

import { useHabits } from '../use-habits';

export const useFilteredHabits = (
  filters: TaskFilterOptions | TaskFilterOptions[],
): Habit[] => {
  const today = useToday();
  const user = useUser();
  const habits = useHabits({
    deletedFilter: DeletedFilter.IncludeDeleted,
  });
  return _useFilteredHabits({ habits, filters, today, user });
};
